import { lazyLoad } from '@utils/router'
const routes = [
  {
    path: '/home/intelligentOfficialDoc/result',
    component: lazyLoad(() =>
      import('@views/intelligentOfficialDoc/pages/Result')
    ),
  },
  {
    path: '/home/intelligentOfficialDoc/exerciseRecord',
    component: lazyLoad(() =>
      import('@views/intelligentOfficialDoc/pages/ExerciseRecord')
    ),
  },
  {
    path: '/home/paper/detail',
    component: lazyLoad(() =>
      import('@views/intelligentOfficialDoc/pages/TopicDetail/index')
    ),
  },
  // 测试、练习须知
  {
    path: '/home/intelligentOfficialDoc/testNote/:testType/:taskId',
    component: lazyLoad(() =>
      import('@views/intelligentOfficialDoc/pages/TestNote')
    ),
  },
  {
    path: '/home/intelligentOfficialDoc',
    exact: true,
    component: lazyLoad(() =>
      import('@views/intelligentOfficialDoc/pages/Index')
    ),
  },
  // 原写作素材和要求
  {
    path: '/home/intelligentOfficialDoc/materialView',
    component: lazyLoad(() =>
      import('@views/intelligentOfficialDoc/pages/TopicDetail/MaterialView')
    ),
  },
]

export default routes
